export default function ConfirmDialog({ message, confirmLabel = 'Delete', onConfirm, onCancel }) {
  return (
    <>
      <div className="fixed inset-0 z-[80] bg-black/50" onClick={onCancel} />
      <div className="fixed inset-x-4 top-1/2 -translate-y-1/2 z-[90] bg-white rounded-2xl shadow-2xl p-5 max-w-sm mx-auto">
        <p className="font-bold text-gray-800 mb-1">Are you sure?</p>
        <p className="text-sm text-gray-500 mb-5">{message}</p>
        <div className="flex space-x-3">
          <button
            onClick={onCancel}
            className="flex-1 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-semibold text-sm"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-xl bg-red-600 text-white font-semibold text-sm"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </>
  )
}
